export class PluginDocumentationModel {
  projectKeyClassName: string;
  htmlContent: string | null;
}
